import { useNavigate, useParams } from 'react-router-dom';
import { ProfileExample } from '../../components/profile/ProfileExample';
import { CheckIsBlocked } from './CheckIsBlocked';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { useState } from 'react';
import config from '../../config';
import chatService from '../../services/chat.service';
import { toast } from 'react-toastify';
import { apiGifts } from '../../api/apiGifts.api';
import SendGiftsModal from '../../components/gifts/SendGiftsModal';

export function ProfileChat() {
  const { id: userId } = useParams();

  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const [isOpenPresentShop, setIsOpenPresentShop] = useState(false);

  const handleToFindOrCreateChat = async () => {
    try {
      const res = await chatService.getChatToUserId(axiosPrivate, userId);
      navigate(`/chats/${res.data._id}`);
    } catch (error) {
      console.error('[Profile] getChatToUserId:', error);
      toast.error('Ошибка при попытке открыть чат с пользователем');
    }
  };

  const onSendGiftToStartChatting = async (giftId) => {
    try {
      const res = await apiGifts.sendGift(axiosPrivate, { recipientId: userId, giftId: giftId });
      if (res.data.data.ok) {
        await handleToFindOrCreateChat();
      }
    } catch (error) {
      console.error('[Profile] Error sending gift:', error);
      toast.error(error.response.data.message || 'Ошибка отправки подарка');
    }
  };

  return (
    <CheckIsBlocked userId={userId}>
      <SendGiftsModal
        isOpen={isOpenPresentShop}
        onClose={() => setIsOpenPresentShop(false)}
        renderTitle={() => (
          <h2 className="text-[18px] font-semibold text-white text-center leading-[1.5] font-raleway">
            Обозначь себя, сделав человеку приятно. Это шаг к новым знакомствам!
          </h2>
        )}
        onSend={onSendGiftToStartChatting}
      />
      <ProfileExample
        userId={userId}
        actionButtons={
          <>
            <button
              onClick={() => setIsOpenPresentShop(true)}
              className="size-[58px] flex items-center justify-center rounded-full border-[2px] border-white bg-black/30"
            >
              <img src="/icons/gifts.svg" alt="chat" />
            </button>
          </>
        }
      />
    </CheckIsBlocked>
  );
}
